import React from 'react';
import {Route} from 'react-router-dom';
import {OrderDetails} from '../';
import {pathnames as P} from '../../_common/constants/pathnames';

export const orderDetailsRoute = <Route path={P.ORDER_DETAILS} component={OrderDetails}/>;
